import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { TopBanner } from './TopBanner';
import { Header } from './Header';
import { Footer } from './Footer';
import { LegalBanner } from './LegalBanner';

export const Layout = ({ children }) => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  const isTerms = pathname === '/cgv';
  return (
    <div className="min-h-screen flex flex-col bg-nw-black">
      <TopBanner />
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      {isTerms && <LegalBanner />}
    </div>
  );
};
